import { render, staticRenderFns } from "./SlideSingle.vue?vue&type=template&id=6890f940"
import script from "./SlideSingle.vue?vue&type=script&lang=js"
export * from "./SlideSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports